import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  selector as sendResetPasswordEmailApi,
  sendEmail,
  resetStatus,
} from "./sendResetPasswordEmailSlice";
import { Status } from "../../../common/constants";
import useNotification from "../../notification/useNotification";
import { validateEmail } from "../../../common/utils";

const useResetPassword = (onHide: () => void) => {
  const [email, setEmail] = useState<string>("");
  const [emailError, setEmailError] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const resetPasswordEmailResponse = useSelector(sendResetPasswordEmailApi);
  const { showSuccessNotification, showWarningNotification } =
    useNotification();
  const dispatch: any = useDispatch();

  const handleResetPassword: () => void = useCallback(
    async function () {
      await dispatch(
        sendEmail({
          email,
        })
      );
    },
    [email, dispatch]
  );

  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
    setEmail(e.target.value);
    setEmailError(
      validateEmail(e.target.value) ? "" : "Please enter a valid email address"
    );
  };

  useEffect(() => {
    if (resetPasswordEmailResponse.status === Status.PENDING) {
      onHide();
      setLoading(true);
    } else if (resetPasswordEmailResponse.status === Status.SUCCESS) {
      setLoading(false);
    } else if (resetPasswordEmailResponse.status === Status.FAILED) {
      setLoading(false);
    }
  }, [resetPasswordEmailResponse.status, dispatch]);

  return {
    email,
    setEmail,
    emailError,
    setEmailError,
    loading,
    setLoading,
    handleResetPassword,
    handleEmailChange
  };
};

export default useResetPassword;
